import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonSizeEnum } from "@blk/aladdin-web-components";
import { isEqual } from "lodash";
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { ModalName } from "components/modal/types";
import { usePermission, Permissions } from "feature-flag";
import { appInsightEvents, language } from "language/default";
import { openModal } from "store/modal";
const mLanguage = language.en.administration.dataAdministration;
export const InsExportDataAdministrationAction = (props) => {
    const dispatch = useDispatch();
    const selectedRows = useSelector((state) => state.grids.state[props.selectedExportGrid]?.selectedRows, isEqual) ?? [];
    const exportDataPermission = usePermission([Permissions.EXPORT_DATA]);
    const onExportClicked = () => {
        dispatch(openModal({
            content: {
                id: ModalName[ModalName.ExportData],
                modalName: ModalName.ExportData,
                parameters: {
                    appInsightsCustomDimension: {
                        entityType: props.selectedEntity,
                        eventName: appInsightEvents.customEvents.names.RawTemplateExport
                    },
                    exportEntity: props.selectedEntity,
                    selection: selectedRows
                }
            },
            title: mLanguage.exportData.modalTitle,
            type: "action"
        }));
    };
    return React.createElement(React.Fragment, null,
        React.createElement(AuxButton, { isDisabled: selectedRows.length === 0 || !exportDataPermission, icon: "download", size: AuxButtonSizeEnum.SMALL, onClick: exportDataPermission ? onExportClicked : undefined, label: mLanguage.exportData.label }));
};
